export const GTAG = process.env.NEXT_PUBLIC_GTAG ?? ''

export const isAnalyticsEnabled = GTAG || false
export const isAnalyticsDisabled = !isAnalyticsEnabled
